import { type BillingPlanResponse } from "@/api/client";
import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

interface PlanSelectorProps {
  plan: BillingPlanResponse;
  onOpenModal: () => void;
}

export default function PlanSelector({ plan, onOpenModal }: PlanSelectorProps) {
  const isCanceled = plan.subscription_status === "canceled";

  return (
    <section className={cn(theme.cards.base, "p-6")}>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Change Plan</h2>
      <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">Select a different plan:</p>
      <button
        onClick={onOpenModal}
        disabled={isCanceled}
        className={cn(
          theme.buttons.secondary,
          "px-6 py-3 rounded-xl",
          isCanceled && "opacity-50 cursor-not-allowed",
        )}
      >
        Change Plan
      </button>
      {isCanceled && (
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
          Please resubscribe to change your plan.
        </p>
      )}
    </section>
  );
}

